import React from 'react'
import { graphql } from 'gatsby'

import { Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody } from 'react-accessible-accordion'
import { AccordionComponent, AccordionIcon } from '../../../shared/Accordion/Accordion.style'
import { groupByData } from '../../../utils/siteHelper'

import { Container } from '../../Container/Container.style'
import { PressCentreContainer } from './PressCentre.style'

export default function PressCentre({ pressCentreItems }) {
  const groupDataByYear =
    pressCentreItems && groupByData(
      pressCentreItems, 'publishDate', 'desc'
    )
  return (
    groupDataByYear &&
    groupDataByYear.map(pressCentreItems => {
      return (
        <Container key={pressCentreItems.id}>
          <PressCentreContainer>
            <div className="publishYear">
              <h3>{pressCentreItems.publishDate}</h3>
            </div>
            <div className="pressAccordion">
              {pressCentreItems &&
                pressCentreItems.data.map(item => {
                  return (
                    <AccordionComponent key={item.id}>
                      <Accordion>
                        <AccordionItem>
                          <AccordionItemTitle>
                            <h6>
                              {item.directoryName}
(
                              {item.media.length}
)
                            </h6>
                            <div className="publishDate">{item.date}</div>
                            <AccordionIcon />
                          </AccordionItemTitle>
                          <AccordionItemBody>
                            {item.media &&
                              item.media.map(item => {
                                return (
                                  <p key={item.id}>
                                    <a
                                      className="docLink"
                                      href={item.media[0].file.url}
                                      target="blank"
                                    >
                                      {item.media[0].title}
                                    </a>
                                  </p>
                                )
                              })}
                          </AccordionItemBody>
                        </AccordionItem>
                      </Accordion>
                    </AccordionComponent>
                  )
                })}
            </div>
          </PressCentreContainer>
        </Container>
      )
    })
  )
}

export const PressCentreFragment = graphql`
  fragment PressCentreFragment on ContentfulPressCentreContainer {
    pressCentreItems {
      id
      directoryName
      date(formatString: "YYYY MMMM")
      publishDate: date(formatString: "YYYY")
      media {
        id
        title
        media {
          title
          file {
            contentType
            url
          }
        }
      }
    }
  }
`
